module.exports = __webpack_public_path__ + "template.apple-pay-599402d5.html";